import axios from 'axios'

const URL_PATH = 'api/adesao'

class RevisoesAdesaoApiClient {
	async buscarRevisoesDisponivel(idAdesao) {
		return await axios.get(`${URL_PATH}/revisao/disponivel?idAdesao=${idAdesao}`)
	}

	async criarRevisaoAdesao(idAdesao, body) {
		return await axios.post(`${URL_PATH}/${idAdesao}/revisao`, body)
	}
}

export default new RevisoesAdesaoApiClient()
